import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'
import { Box } from 'reflexbox'
import { NextSeo } from 'next-seo'
import getConfig from 'next/config'

import layoutTheme from 'theme/layout-theme'
import PageTitle from 'components/PageTitle'
import BoatMainImage from 'components/BoatMainImage'
import Article from 'components/Article'
import { getSinglePost } from 'helpers/wordpress/wp-api'

const { publicRuntimeConfig } = getConfig()
const { CLOUDINARY_URL } = publicRuntimeConfig

const cmsPost = ({ data, i18n }) => {
    const postData = i18n.language === 'en' ? data : data.translation

    const seoData = {
        title: `${postData.seo.title} | Merk & Merk`,
        description: postData.seo.metaDesc,
        canonical: `https://merkandmerk.${i18n.language === 'en' ? 'com' : 'de'}/yacht-news/${
            data.categories.nodes[0].slug
        }/${data.slug}`,
        openGraph: {
            title: `${postData.seo.title} | Merk & Merk`,
            description: postData.seo.metaDesc,
            url: `https://merkandmerk.${i18n.language === 'en' ? 'com' : 'de'}/yacht-news/${
                data.categories.nodes[0].slug
            }/${data.slug}`,
            images: [
                {
                    url: postData.featuredImage
                        ? postData.featuredImage.node.sourceUrl
                        : `${CLOUDINARY_URL}/v1582632369/Static/sell-image_hace64.jpg`
                }
            ]
        },
        languageAlternates: [
            {
                hrefLang: 'en',
                href: `https://merkandmerk.com/yacht-news/${data.categories.nodes[0].slug}/${data.slug}`
            },
            {
                hrefLang: 'de',
                href: `https://merkandmerk.de/yacht-news/${data.categories.nodes[0].slug}/${data.slug}`
            }
        ]
    }

    return (
        <main>
            <NextSeo {...seoData} />
            <Box theme={layoutTheme} px={20} mt={[35, null, 70, 100, 150]} mb={[35, null, 70, 80]} variant="center1280">
                <PageTitle
                    title={postData.title}
                    subtitle={postData.excerpt}
                    titleTag="h1"
                    subtitleTag="h2"
                    isBlogPost
                />
            </Box>
            {postData.featuredImage && (
                <Box theme={layoutTheme} px={20} mb={[70, null, null, 130]} maxWidth={1600} mx="auto">
                    <BoatMainImage
                        image={postData.featuredImage.node.sourceUrl}
                        alt={postData.featuredImage.node.altText}
                    />
                </Box>
            )}
            <Box theme={layoutTheme} mb={[55, null, null, 260]} mx="auto">
                <Article content={postData.content} contain />
            </Box>
        </main>
    )
}

cmsPost.propTypes = {
    data: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    i18n: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired
}
export async function getServerSideProps({ params, preview = false, previewData }) {
    const data = await getSinglePost(params.slug)

    return {
        props: {
            data: data.post
        }
    }
}

export default withTranslation([''])(cmsPost)
